export * from '@primeuix/themes/aura/inlinemessage';
export { default } from '@primeuix/themes/aura/inlinemessage';
